import React, { useState } from "react";
import { TextButton } from "kubra-ux-forge";
import { Outlet, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { BillerLogo } from "components/ezpay/common/biller-logo";
import { MENU_NAMESPACE } from "constants/i18n-namespaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import routing from "routing";
import { faSignOut } from "@fortawesome/pro-regular-svg-icons";
import { setAppLoading } from "actions/appStateActions";
import { useDispatch, useSelector } from "react-redux";
import { getPayableSession } from "selectors/payableSession";
import { setPayableSession } from "actions/payableSessionActions";
import IamApi from "api/IamApi";
import { USER_LOGOUT } from "actions/userActions";
import { getBiller } from "selectors";
import { IContactInfo, IImageResources } from "types/biller";
import { LanguageMenu } from "../language-menu/language-menu";
import { getLanguageLabel } from "utilities/language";

export const PayableHeader = (props: any) => {
  const payableSession = useSelector(getPayableSession);
  const biller = useSelector(getBiller);

  const imageResources = biller?.properties?.find((element) => {
    return element.name === "ImageResources";
  }) as IImageResources;

  const contactUs = biller?.properties?.find((element) => {
    return element.name === "InstanceConfiguration";
  }) as IContactInfo;

  const { t, i18n } = useTranslation();
  const [languageModalDisplay, setLanguageModalDisplay] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogoutClick = async () => {
    dispatch(setAppLoading(true));
    dispatch({ type: USER_LOGOUT });
    dispatch(setPayableSession(undefined));
    IamApi.ezpay.logout();
    navigate(routing.index());
  };

  const closeLanguagesModal = () => {
    setLanguageModalDisplay(false);
  };

  const getLanguageDisplayValue = (language: string) => {
    return getLanguageLabel(language, "menu", t);
  };

  return (
    <>
      {imageResources?.properties?.logoURL && contactUs?.properties?.website ? (
        <BillerLogo
          billerLogo={imageResources?.properties?.logoURL}
          billerUrl={contactUs?.properties?.website}
        />
      ) : (
        <div className="biller-logo-container"></div>
      )}
      <div className="lang-exit-container">
        {/* language modal, sheet and button */}
        <LanguageMenu
          isMobile={props.isMobile}
          languageModalDisplay={languageModalDisplay}
          closeLanguagesModal={closeLanguagesModal}
          setLanguageModalDisplay={setLanguageModalDisplay}
          getLanguageDisplayValue={getLanguageDisplayValue}
          i18nLang={i18n.language}
        />
        {payableSession?.payable?.category?.toLowerCase() === "account" &&
          !props.isMobile &&
          payableSession?.channel !== "CallCenter" && (
            <TextButton
              icon={<FontAwesomeIcon icon={faSignOut} />}
              onClick={() => handleLogoutClick()}
              dataCy="button-logout"
            >
              {t("change-account", { ns: MENU_NAMESPACE })}
            </TextButton>
          )}
        {payableSession?.payable?.category?.toLowerCase() === "account" &&
          props.isMobile &&
          payableSession?.channel !== "CallCenter" && (
            <>
              <div className="vertical-separator"></div>
              <TextButton
                className="log-out-button"
                icon={<FontAwesomeIcon icon={faSignOut} />}
                onClick={() => handleLogoutClick()}
                dataCy="button-logout"
                aria-label={t("change-account", { ns: MENU_NAMESPACE })}
              >
                {""}
              </TextButton>
            </>
          )}
      </div>

      <Outlet context={payableSession} />
    </>
  );
};
